module.exports = __webpack_public_path__ + "assets/8588ff26f1f7d6e34a0c1422992093b7.png";